export var AuditActorType;
(function (AuditActorType) {
    AuditActorType["USER"] = "user";
    AuditActorType["SYSTEM"] = "system";
    AuditActorType["ADMIN_CLI"] = "admin_cli";
})(AuditActorType || (AuditActorType = {}));
//# sourceMappingURL=audit-actor-type.enum.js.map